import React from "react";
import creditCardIcon from "../../../assets/creditCardIcon.svg";
import styles from "./Card.module.scss";

const Card = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <input type="radio" name="radio" />

        <img src={creditCardIcon} alt="credit-card" />
        <h4>Tyler Smith</h4>
      </div>
      <div className={styles.right}>
        <p>**** 4578</p>
        <small>02/24</small>
      </div>
    </div>
  );
};

export default Card;
